import React from "react"
import { Link, useLocation } from "react-router-dom"
import { SessionRole } from "~/api/dto/auth/session-role"

import { cn } from "~/ui-rtk/utils/tailwind-utils"

import type { NavItem } from "../types"
import usePostHogFeatureFlags from "~/ui-rtk/hooks/posthog-feaures"

export type TSidebarNestedItemProps = NavItem & {
  onClick?: () => void
  sessionRole: SessionRole
}

export const Subitem: React.FC<TSidebarNestedItemProps> = ({
  path,
  label,
  availableTo,
  onClick,
  sessionRole,
  featureFlag,
  isHidden,
}) => {
  const location = useLocation()
  const isActive = location.pathname === path

  const handleClick = () => {
    // Allow default Link behavior for standard clicks
    // Call onClick callback after navigation
    onClick?.()
  }

  if (featureFlag && !usePostHogFeatureFlags(featureFlag)) {
    return null
  }

  if (!availableTo?.includes(sessionRole)) {
    return null
  }

  if (isHidden && isHidden()) {
    return null
  }

  return (
    <li>
      <Link
        to={path}
        onClick={handleClick}
        className={cn(
          "block px-3 py-2 hover:bg-gray/[.1] hover:text-platinum rounded cursor-pointer whitespace-nowrap",
          isActive ? "text-platinum bg-gray/[.1]" : "text-gray",
        )}
      >
        {label}
      </Link>
    </li>
  )
}
